
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component({
    name: 'InvitesList',
    methods: {
      ...mapActions('vacancies', ['fetchVacanciesListDropdown'])
    }
  })
  export default class InvitesList extends Vue {
    @Prop() readonly list: [];
    @Prop({ default: false }) readonly isItSearch: boolean;
    @Prop() readonly filter_temp_selected_vacancy: [];
    @Prop() readonly filter_temp_selected_statuses: [];
    @Prop() readonly filter_temp_dates: [];
    @Prop() readonly filter_temp_selected_creators: [];
    @Prop() readonly filter_temp_selected_tags: [];
    @Prop() readonly temp_name: string;
    @Prop() readonly temp_email: string;
    @Prop() readonly temp_phone: string;
    @Prop({ default: 'none' }) readonly show_filter: string;
    @Prop() readonly filter_loaded: boolean;
    @Prop() readonly filter_creators: [];
    @Prop() readonly filter_tags: [];
    @Prop() readonly filter_statuses: [];
    @Prop() readonly filter_vacancies: [];

    private isSelectedAllFilters = {};

    get selectedAll() {
      if (!this.list.length) {
        return false;
      }
      return this.list.every(invite => this.$store.getters['invites/isSelected'](invite));
    }

    set selectedAll(val) {
      this.list.forEach(invite =>
        this.$store.commit('invites/select', { model: invite, value: val })
      );
    }

    get sorting() {
      return this.$store.getters['invites/sorting'];
    }

    get sortingIcon() {
      return {
        'fa-caret-down': this.sorting.order === 'desc',
        'fa-caret-up': this.sorting.order === 'asc'
      };
    }

    get filter() {
      return this.$store.getters['invites/filter'];
    }

    get statuses() {
      return this.$store.getters['dictionary/responseStatuses'];
    }

    public setSortingMethod(method) {
      const sorting = this.$store.getters['invites/sorting'];
      this.$store.dispatch('invites/updateSorting', {
        name: method,
        order: sorting.name !== method || sorting.order === 'desc' ? 'asc' : 'desc'
      });
    }

    public fetchInvites() {
      this.$store.dispatch('invites/fetch');
    }
    public set_temp_name(name) {
      this.$emit('set_temp_name', name);
    }
    public set_temp_phone(phone) {
      this.$emit('set_temp_phone', phone);
    }
    public set_temp_email(email) {
      this.$emit('set_temp_email', email);
    }
    public set_filter_temp_dates(model) {
      this.$emit('set_filter_temp_dates', model.result);
    }
    public set_filter_temp_selected_vacancy(model) {
      this.$emit('set_filter_temp_selected_vacancy', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    }
    public set_filter_temp_selected_statuses(model) {
      this.$emit('set_filter_temp_selected_statuses', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    }
    public set_filter_temp_selected_creators(model) {
      this.$emit('set_filter_temp_selected_creators', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    }
    public set_filter_temp_selected_tags(model) {
      this.$emit('set_filter_temp_selected_tags', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    }
    public apply_filter(filter) {
      if (this.isSelectedAllFilters[filter] && this[`${filter}_clear`]) {
        this[`${filter}_clear`]();
        return;
      }
      this.$emit('apply_filter', filter);
    }
    public cancel_filter() {
      this.$emit('cancel_filter');
    }
    public name_clear() {
      this.$emit('name_clear');
    }
    public phone_clear() {
      this.$emit('phone_clear');
    }
    public email_clear() {
      this.$emit('email_clear');
    }
    public status_id_clear() {
      this.$emit('status_id_clear');
    }
    public date_clear() {
      this.$emit('date_clear');
    }
    public vacancy_id_clear() {
      this.$emit('vacancy_id_clear');
    }
    public creator_clear() {
      this.$emit('creator_clear');
    }
    public set_show_filter(v) {
      this.$emit('set_show_filter', v);
    }

    async created() {
      await this.fetchVacanciesListDropdown({ isActive: true });
    }
  }
